import styles from './Class.module.scss';
import { ReactComponent as LISVG } from '../../../../../../assets/img/cluster/rezidents/programms/liPurple.svg';

const Class = () => {
  return (
    <div className={styles.content}>
      <div className={styles.leftColumn}>
        <p className={styles.title}>по виду деятельности</p>
        <ul className={styles.list}>
          <li>
            <LISVG />
            Постоянные резиденты 
          </li>
          <li>
            <LISVG />
            Якорные резиденты
          </li>
          <li>
            <LISVG />
            Сервисные резиденты
          </li>
        </ul>
        <p className={styles.title}>
          по сроку ведения предпринимательской деятельности
        </p>
        <ul className={styles.list2}>
          {/* <li>
            <LISVG />
            Начинающие предприниматели
          </li> */}
          <li>
            <LISVG />
            Действующие предприниматели
          </li>
        </ul>
        <div className={styles.stavka}>
          <p className={styles.stavkaText}>
            арендная
            <br /> СТАВКА
          </p>
          <p>=730-740 руб. /кв.м</p>
        </div>
      </div>
      <div className={styles.rightColumn}>
        <div className={styles.cards}>
          {/* <div className={styles.card}>
            <p className={styles.cardTitle}>начинающие</p>
            <p className={styles.cardPercent}>
              О-3 МЕС. - 0<br /> 3-6 МЕС. - 15%
              <br /> 6-9 МЕС. - 26% <br /> 9-12 МЕС. - 35%
            </p>
            <p className={styles.cardText}>
              вновь зарегистрированные и действующие менее 2 (двух) лет
            </p>
            <p className={styles.cardText2}>
              проекты в первичной стадии развития и имеют потенциал для быстрого
              роста
            </p>
          </div> */}
          <div className={styles.card}>
            <p className={styles.cardTitle2}>действующие</p>
            <p className={styles.cardPercent}>
              0-11 МЕС. - 50%
              <br /> 12-23 МЕС. - 75%
              <br /> 24-35 МЕС. - 100%
            </p>
            <p className={styles.cardText}>
              проекты в стадии активного роста и развития
            </p>
            <p className={styles.cardText2}>
              бизнес, утвердившийся на рынке и приносящий стабильный доход
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Class;
